import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogButtonConfig } from '@zelis/dls/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rts-claim-overlay',
  templateUrl: './claim-overlay.component.html',
  styleUrls: ['./claim-overlay.component.scss'],
})
export class ClaimOverlayComponent {
  public address: string;
  public name: string;
  public rewardTypeKey: string;
  public buttons: DialogButtonConfig[] = [
    {
      isCloseButton: true,
      content: this.translateService.instant('claim_overlay_cancel'),
      onClick: this.close.bind(this),
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      result: any;
      rewardType: any;
      reward: any;
      referenceNumber: string;
    },
    public dialogRef: MatDialogRef<ClaimOverlayComponent>,
    private translateService: TranslateService
  ) {
    this.formatAddress(this.data.result);
    this.setName();
    this.setRewardsTypeKey();
  }

  public close(): void {
    this.dialogRef.close();
  }

  private formatAddress(provider: any): void {
    if (!!provider.addr_line2) {
      this.address = `${provider.addr_line1} ${provider.addr_line2}, ${provider.city}, ${provider.state} ${provider.postal_code}`;
    } else {
      this.address = `${provider.addr_line1}, ${provider.city}, ${provider.state} ${provider.postal_code}`;
    }
  }

  private setName(): void {
    this.name =
      this.data.result.provider_type === 'F'
        ? this.data.result.location_name
        : this.data.result.name;
  }

  private setRewardsTypeKey(): void {
    this.rewardTypeKey =
      this.data.rewardType === 'quality_rewards' ? 'quality_rewards_' : '';
  }
}
